import {
  GET_DASHBOARD_REVENUE,
  GET_DASHBOARD_REVENUE_SUCCESS,
  GET_DASHBOARD_REVENUE_FAIL,
  GET_DASHBOARD_OCCUPANCY,
  GET_DASHBOARD_OCCUPANCY_SUCCESS,
  GET_DASHBOARD_OCCUPANCY_FAIL,
  GET_LOTS_SOLD,
  GET_LOTS_SOLD_SUCCESS,
  GET_LOTS_SOLD_FAIL,
} from "./actionTypes"

export const getDashboardRevenue = payload => ({
  type: GET_DASHBOARD_REVENUE,
  payload,
})

export const getDashboardRevenueSuccess = payload => ({
  type: GET_DASHBOARD_REVENUE_SUCCESS,
  payload,
})

export const getDashboardRevenueFail = error => ({
  type: GET_DASHBOARD_REVENUE_FAIL,
  payload: error,
})

export const getDashboardOccupancy = payload => ({
  type: GET_DASHBOARD_OCCUPANCY,
  payload,
})

export const getDashboardOccupancySuccess = payload => ({
  type: GET_DASHBOARD_OCCUPANCY_SUCCESS,
  payload,
})

export const getDashboardOccupancyFail = error => ({
  type: GET_DASHBOARD_OCCUPANCY_FAIL,
  payload: error,
})

export const getLotsSold = () => ({
  type: GET_LOTS_SOLD
})

export const getLotsSoldSuccess = LotsSold => ({
  type: GET_LOTS_SOLD_SUCCESS,
  payload: LotsSold,
})

export const getLotsSoldFail = error => ({
  type: GET_LOTS_SOLD_FAIL,
  payload: error,
})
